<mat-card>
  <app-card-header
    [title]="'Sincronizar activos con Soflex'"
    icono="sync"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <section class="inputs-group">
      <app-cliente-selector
        [filterModules]="['integracionSoflex']"
        placeholder="Cliente a sincronizar"
        (clienteChange)="onClienteChange($event)"
        style="width: 100%"
      ></app-cliente-selector>
    </section>

    <div class="soflex-cuerpo">
      <app-info-banner
        icon="info"
        title="Qué se envía"
        message='Se envía un request por flota con los vehículos que todavía no están sincronizados. Los que ya figuran como sincronizados se omiten: para volver a enviarlos, editarlos o usar la acción "Marcar como no sincronizado con Soflex" del listado.'
        color="blue"
        [closable]="false"
        margin="0"
      ></app-info-banner>

      <!-- Modo test -->
      <div>
        <mat-checkbox [checked]="modoTest" (change)="onModoTestChange($event)">
          Modo prueba
        </mat-checkbox>
        <small class="soflex-ayuda">
          Genera un archivo con lo que se enviaría, sin enviarlo
        </small>
      </div>

      @if (modoTest) {
        <app-info-banner
          icon="info"
          title="Modo de Prueba Activado"
          message="En modo prueba no se enviará información a Soflex: se genera un archivo con lo que se enviaría y queda disponible para descargar."
          color="yellow"
          [closable]="false"
          margin="0"
        ></app-info-banner>
      }

      @if (resultado) {
        <app-info-banner
          [icon]="resultado.success ? 'check_circle' : 'error'"
          [title]="
            resultado.success
              ? 'Sincronización Exitosa'
              : 'Error en Sincronización'
          "
          [message]="getResultadoMessage()"
          [color]="resultado.success ? 'green' : 'red'"
          [closable]="false"
          margin="0"
        ></app-info-banner>
      }

      @if (resultado?.urlSimulacion || resultado?.urlBodies) {
        <div style="display: flex; flex-direction: column; gap: 0.5em">
          @if (resultado?.urlSimulacion) {
            <a
              irxBoton="secundario"
              [href]="resultado!.urlSimulacion"
              target="_blank"
              rel="noopener"
              download
            >
              <mat-icon>file_download</mat-icon>
              Descargar simulación completa
            </a>
          }
          @if (resultado?.urlBodies) {
            <a
              irxBoton="secundario"
              [href]="resultado!.urlBodies"
              target="_blank"
              rel="noopener"
              download
            >
              <mat-icon>data_object</mat-icon>
              Descargar bodies del request
            </a>
          }
        </div>
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="cerrar()"
      [disabled]="loading"
    >
      Cerrar
    </button>
    <button
      irxBoton="principal"
      type="button"
      (click)="sincronizar()"
      [disabled]="loading || !clienteSeleccionado"
    >
      @if (loading) {
        <mat-spinner diameter="20" style="display: inline-block"></mat-spinner>
      } @else {
        <mat-icon>sync</mat-icon>
      }
      Sincronizar
    </button>
  </mat-card-actions>
</mat-card>
